// ═══ 관세사 전송 카드 — Invoice.js에서 분리 ═══
// 임시저장 / 출력 / 관세사 전송 버튼 + 누락 서류 경고 + 강제 전송
// + 카톡 공유 (2026-04-21, 항상 노출 + 자동 임시저장)
import React, { useState, useEffect } from 'react';
import { API, authFetch } from '../utils/api';

var KAKAO_APP_KEY = '16d4abc8bd86cf23c6e2e1a54f55f13b';

function InvoiceSend(props) {
  var c = props.c;
  // 자동 저장 후 공유 트리거 — savedInvoiceId 비어있을 때 saveDraft 호출 후
  // state 전파 대기 (useEffect 로 savedInvoiceId 변화 감지)
  var pendingShareState = useState(false);
  var pendingShare = pendingShareState[0];
  var setPendingShare = pendingShareState[1];

  // Kakao SDK 초기화 (1회만)
  useEffect(function() {
    try {
      if (typeof window !== 'undefined' && window.Kakao && !window.Kakao.isInitialized()) {
        window.Kakao.init(KAKAO_APP_KEY);
      }
    } catch (e) { /* silent */ }
  }, []);

  // pendingShare + savedInvoiceId 둘 다 truthy → 실제 공유 실행
  useEffect(function() {
    if (pendingShare && c.savedInvoiceId) {
      setPendingShare(false);
      performShare(c.savedInvoiceId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingShare, c.savedInvoiceId]);

  function performShare(invId) {
    if (typeof window === 'undefined' || !window.Kakao || !window.Kakao.isInitialized || !window.Kakao.isInitialized()) {
      c.showToast && c.showToast('\uCE74\uCE74\uC624 \uACF5\uC720 \uC900\uBE44 \uC911 \uC624\uB958\uAC00 \uBC1C\uC0DD\uD588\uC2B5\uB2C8\uB2E4', 'err');
      return;
    }
    authFetch(API + '/invoices/' + invId + '/share-token')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        if (!d || !d.success || !d.token) {
          c.showToast && c.showToast('\uACF5\uC720 \uB9C1\uD06C \uBC1C\uAE09 \uC2E4\uD328', 'err');
          return;
        }
        var origin = (typeof window !== 'undefined' && window.location) ? window.location.origin : 'https://autodex.kr';
        // 서버가 첨부 유무 분기: 첨부 없으면 Excel 직접 스트리밍, 있으면 share.html 로 redirect
        var pageUrl = origin + '/api/invoices/share/' + d.token + '/auto';
        // 카드 제목 — "업체명 목적지 선적방식건 진행요망" (예: "부타무역 LIBYA 컨테이너건 진행요망")
        var companyName = (c.shipCo && c.shipCo.companyName) || 'AUTODEX';
        var destParts = String(c.toPort || '').split(',').map(function(s) { return s.trim(); }).filter(Boolean).join(' ');
        var shippingLabel = c.shippingType === 'container' ? '\uCEE8\uD14C\uC774\uB108' : '\uB85C\uB85C\uC120';
        var cardTitle = companyName + (destParts ? ' ' + destParts : '') + ' ' + shippingLabel + '\uAC74 \uC9C4\uD589\uC694\uB9DD';
        var carCount = (c.cars && c.cars.length) || 0;
        var cardDesc = '\uCC28\uB7C9 ' + carCount + '\uB300 \u00B7 24\uC2DC\uAC04 \uC720\uD6A8';
        try {
          window.Kakao.Share.sendDefault({
            objectType: 'feed',
            content: {
              title: cardTitle,
              description: cardDesc,
              imageUrl: 'https://autodex.kr/autodex-og.png',
              link: { mobileWebUrl: pageUrl, webUrl: pageUrl }
            },
            buttons: [{
              title: '\uD30C\uC77C \uBAA9\uB85D \uBCF4\uAE30',
              link: { mobileWebUrl: pageUrl, webUrl: pageUrl }
            }]
          });
        } catch (e) {
          c.showToast && c.showToast('\uCE74\uCE74\uC624 \uACF5\uC720 \uC2E4\uD328: ' + (e.message || ''), 'err');
        }
      })
      .catch(function() {
        c.showToast && c.showToast('\uACF5\uC720 \uB9C1\uD06C \uC694\uCCAD \uC2E4\uD328', 'err');
      });
  }

  var shareKakao = function() {
    // 이미 저장된 경우 → 바로 공유
    if (c.savedInvoiceId) {
      performShare(c.savedInvoiceId);
      return;
    }
    // 미저장 → 자동 임시저장 후 useEffect 에서 완료 감지 → 공유
    if (!c.saveDraft) {
      c.showToast && c.showToast('\uC800\uC7A5 \uD568\uC218\uB97C \uCC3E\uC744 \uC218 \uC5C6\uC2B5\uB2C8\uB2E4', 'err');
      return;
    }
    setPendingShare(true);
    try {
      var p = c.saveDraft();
      // saveDraft 가 Promise 반환하면 에러 시 pending 해제
      if (p && typeof p.catch === 'function') {
        p.catch(function() {
          setPendingShare(false);
          c.showToast && c.showToast('\uC784\uC2DC\uC800\uC7A5 \uC2E4\uD328', 'err');
        });
      }
    } catch (e) {
      setPendingShare(false);
      c.showToast && c.showToast('\uC800\uC7A5 \uC624\uB958: ' + (e.message || ''), 'err');
    }
  };

  var shareBusy = pendingShare || c.savingDraft;

  return (
    <div className="card" style={{padding:16}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
        <h3 style={{fontSize:14,margin:0}}>관세사 전송</h3>
        <span style={{padding:'3px 10px',borderRadius:12,fontSize:11,fontWeight:700,background:c.invoiceStatus==='sent'?'#dcfce7':c.invoiceStatus==='ready'?'#fff7ed':'#f1f5f9',color:c.invoiceStatus==='sent'?'#166534':c.invoiceStatus==='ready'?'#c2410c':'#64748b',border:'1px solid '+(c.invoiceStatus==='sent'?'#86efac':c.invoiceStatus==='ready'?'#fdba74':'#e2e8f0')}}>{c.invoiceStatus==='sent'?'✅ 발송완료':c.invoiceStatus==='ready'?'⚡ 발송대기':'임시저장'}</span>
      </div>
      <label style={c.ls}>관세사 이메일</label>
      <input style={c.is} value={c.toEmail} onChange={function(e){c.setToEmail(e.target.value)}} placeholder="customs@example.com" type="email"/>
      {/* 줄 1: 임시저장 / 출력 / 관세사 전송 */}
      <div style={{display:'flex',gap:8,marginTop:12}}>
        <button onClick={function(){c.setConfirmAction({type:'draft',title:'임시저장',msg:'인보이스를 임시저장하시겠습니까?',fn:c.saveDraft})}} disabled={c.savingDraft} style={{padding:'11px 16px',background:c.savingDraft?'#94a3b8':'#f8fafc',color:'#475569',border:'1px solid #d0d5dd',borderRadius:8,fontSize:13,fontWeight:700,cursor:c.savingDraft?'default':'pointer'}}>{c.savingDraft?'저장중...':'임시저장'}</button>
        <button onClick={function(){c.setConfirmAction({type:'print',title:'인보이스 출력',msg:'인보이스를 출력하시겠습니까?',fn:c.printInvoice})}} style={{flex:1,padding:'11px',background:'#475569',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer'}}>출력</button>
        <button onClick={function(){c.setConfirmAction({type:'send',title:'관세사 전송',msg:c.toEmail+'로 인보이스를 전송하시겠습니까?',fn:c.sendToCustoms})}} disabled={c.sending} style={{flex:1,padding:'11px',background:c.sending?'#94a3b8':c.sent?'#16a34a':'#2563eb',color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:c.sending?'default':'pointer'}}>
          {c.sending?'전송 중...':c.sent?'재전송':'관세사 전송'}
        </button>
      </div>
      {/* 줄 2: 카톡 공유 (항상 노출, 미저장 시 자동 임시저장) */}
      <div style={{display:'flex',gap:8,marginTop:8}}>
        <button onClick={shareKakao} disabled={shareBusy} style={{flex:1,padding:'11px',background:shareBusy?'#fef3c7':'#FEE500',color:'#3C1E1E',border:'1px solid #FADA0A',borderRadius:8,fontSize:13,fontWeight:700,cursor:shareBusy?'default':'pointer',opacity:shareBusy?0.7:1}}>
          {shareBusy?'저장 중...':'💬 카톡 공유'}
        </button>
      </div>
      {c.sendWarnings.length>0&&<div style={{background:'#fef2f2',padding:10,borderRadius:8,marginTop:10,fontSize:11,color:'#dc2626'}}>
        <b>누락 서류:</b><br/>{c.sendWarnings.map(function(w,i){return <div key={i}>- {w}</div>})}
        <button className="btn btn-sm" style={{marginTop:8,background:'#dc2626',color:'#fff',border:'none'}} onClick={function(){c.forceSend()}}>경고 무시하고 강제 전송</button>
      </div>}
    </div>
  );
}

export default InvoiceSend;
